export const PASSING_SCORE = 80;
export const BAD_PROMPT_SCORE = 45;
export const SCORE_REVEAL_DELAY_MS = 500;
